import * as React from "react"
import {Table} from "semantic-ui-react"
import {PlaceSign} from "./PlaceSign"
import {BookingListProps} from "./BookingsListTable"
import {paidByStyle, placeSummary, priceSummary} from "./BookingsListCards"

export function BookingsListTableAdmin({bookingItems, onBooking}: BookingListProps) {
  return (
    <Table celled selectable compact="very" fixed>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={2}>Booker</Table.HeaderCell>
          <Table.HeaderCell width={2}>Driver</Table.HeaderCell>
          <Table.HeaderCell width={3}>State</Table.HeaderCell>
          <Table.HeaderCell width={3}>Time</Table.HeaderCell>
          <Table.HeaderCell width={2}>Number</Table.HeaderCell>
          <Table.HeaderCell width={2}>Passenger</Table.HeaderCell>
          <Table.HeaderCell width={5}>From</Table.HeaderCell>
          <Table.HeaderCell width={5}>To</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {bookingItems.map(
          ({
            id,
            state,
            bookingNumber,
            nettPrice,
            paidBy,
            bookingStamp,
            origin,
            destination,
            airportPickup,
            airportDropoff,
            passenger,
            booker,
            driver,
          }) => (
            <Table.Row key={id} onClick={() => onBooking(bookingNumber)}>
              <Table.Cell>{booker ? booker.name : ""}</Table.Cell>
              <Table.Cell>{driver ? driver.name : ""}</Table.Cell>
              <Table.Cell style={paidByStyle(paidBy)}>
                {(state ? state : "") + priceSummary(nettPrice, paidBy)}
              </Table.Cell>
              <Table.Cell>{bookingStamp.format("ddd D MMM HH:mm")}</Table.Cell>
              <Table.Cell>{bookingNumber}</Table.Cell>
              <Table.Cell>{passenger.name}</Table.Cell>
              <Table.Cell>
                <PlaceSign
                  nickname={origin.nickname}
                  pointing={false}
                  type={origin.type}
                  category={origin.category}
                />
                {placeSummary(origin, airportPickup)}
              </Table.Cell>
              <Table.Cell>
                <PlaceSign
                  nickname={destination.nickname}
                  pointing={false}
                  type={destination.type}
                  category={destination.category}
                />
                {placeSummary(destination, airportDropoff)}
              </Table.Cell>
            </Table.Row>
          ),
        )}
      </Table.Body>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/components/BookingsListTableAdmin.tsx